<div class="header-container">
  <header motif-header>
    <div position="left" class="header-left">
      <button
        motif-header-menu
        class="header-menu-icon"
        (click)="toggleMenu()"
        [isOpen]="showMenu"
        aria-label="Toggle menu"
        aria-live="polite"
      ></button>
      <img
        motif-header-logo
        alt="EY Logo"
        aria-label="EY Logo"
        aria-live="polite"
        src="assets/img/EY_Logo_Beam_RGB_White_Yellow.png"
      />
      <span motif-header-title>{{ title }}</span>
    </div>

    <div position="right" class="header-right">
      <span
        motifDropdown
        class="dropdown-toggle-container"
        [placement]="Placement.BOTTOM_LEFT"
        [scrollStrategy]="ScrollStrategy.Close"
      >
        <motif-icon
          motifDropdownToggle
          [iconFunction]="IconoirMoreHoriz"
          [size]="menuIconSize"
          [tabIndex]="0"
          aria-label="User options dropdown toggle"
          aria-live="polite"
        ></motif-icon>

        <div motifDropdownMenu>
          <button
            motifDropdownItem
            (click)="logout()"
            (keydown.enter)="logout()"
          >
            Logout
          </button>
        </div>
      </span>

      @if (profile) {
      <motif-avatar
        [userName]="profile.displayName!"
        size="large"
        aria-label="User Avatar"
        aria-live="polite"
      >
      </motif-avatar>
      }
      <div position="right">
        @if(isAdmin) {
        <!-- <button motifButton class="btn-logout">Export surveys</button> -->
        <button motifButton class="btn-logout" (click)="openModal()">
          Export Surveys
        </button>
        }
        <!-- <button motifButton class="btn-logout" (click)="logout()">Logout</button> -->
      </div>
    </div>
  </header>
</div>
